import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../../app/store';
import { IDaasSignup } from '../../services/DaasSignupService';

type DaasSignupState = {
  step: number;
  signup: IDaasSignup;
};

const init: IDaasSignup = {
  email: '',
  applicationId: '',
  redirectUri: '',
};

const initialState: DaasSignupState = {
  step: 0,
  signup: init,
};

export const slice = createSlice({
  name: 'daasSignup',
  initialState,
  reducers: {
    initDaas: (state, action: PayloadAction<IDaasSignup>) => {
      state.signup = action.payload;
    },
    incrementStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    decrementStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
  },
});

export const { initDaas, incrementStep, decrementStep } = slice.actions;

export const incrementDaasStep =
  (step: number): AppThunk =>
    (dispatch) => {
      dispatch(incrementStep(step));
    };

export const decrementDaasStep =
  (step: number): AppThunk =>
    (dispatch) => {
      dispatch(decrementStep(step));
    };

export const initDaasSignup =
  (init: IDaasSignup): AppThunk =>
    (dispatch) => {
      dispatch(initDaas(init));
    };

export const selectDaasStep = (state: RootState) => state.daasSignup.step;
export const selectDaasSignup = (state: RootState) => state.daasSignup.signup;

export default slice.reducer;
